import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageContextService } from '../../context/storage-context/storage-context.service';
import { authDidSuccessRedirect, hasAuthToken } from '../services/auth.utils';
import { paymentDidFailedRedirect, paymentDidSuccessRedirect } from '@payment/utils';

export const AuthorizationGuard: CanActivateFn = async route => {
  const storage = inject(StorageContextService);
  const router = inject(Router);

  const hasToken = hasAuthToken();
  const affiliateId = route.queryParamMap.get('affiliate');

  if (affiliateId && !hasToken) {
    storage.setItem('affiliate_id', affiliateId);
  }

  if (
    window.location.pathname.includes('/success') ||
    authDidSuccessRedirect() ||
    paymentDidSuccessRedirect() ||
    paymentDidFailedRedirect()
  )
    return true;

  if (hasToken) {
    await router.navigateByUrl('/app/home');
    return false;
  }
  return true;
};
